import React from "react";

export const ArrowLeft = ({
  color,
  size,
  onClick,
}: {
  color: string;
  size: number;
  onClick?: () => void;
}) => (
  <svg
    onClick={onClick}
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    transform="rotate(180)"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5061 20.0863L14.2531 30.3394L16.3744 32.4607L28.7488 20.0863L16.3744 7.71196L14.2531 9.83328L24.5061 20.0863Z"
      fill={color}
    />
  </svg>
);
